export const STATUSES = {
  ACTIVED: "actived",
  COMPLETED: "completed"
};

export const STATUSES_NAMES = {
  [STATUSES.ACTIVED]: "Формирование табеля",
  [STATUSES.COMPLETED]: "Табель сформирован"
};